import { useState } from 'react';
import { useSelector } from 'react-redux';
import { FlexContainer, Spinner, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import ValidationButtons from 'Containers/Datagathering/components/ValidationButtons';
import { useFetchSatUserStage } from 'Containers/Datagathering/hooks';
import TwoColLayout from 'Components/Layouts/TwoColLayout';
import ContentContainer from 'Components/UI/ContentContainer';
import { routes } from 'Constants/routes';
import model from './model';
import * as Styled from './styles';

const DataGatheringValidationAccess = (): JSX.Element => {
  const [value, setValue] = useState<string>('');
  const { t } = useTranslation(locizeNS.DG);
  const isPreviousYears = useSelector(routeStateSelector);
  const { isLoading } = useFetchSatUserStage(isPreviousYears);

  const nextScreen = (): void => {
    if (value === 'rfc') {
      history.push(routes.DATAGATHERING_IDENTIFICATION_RFC);
    } else {
      history.push(routes.DATAGATHERING_IDENTIFICATION_EFIRMA);
    }
  };
  const prevScreen = (): void => {
    history.push(routes.DASHBOARD);
  };

  return (
    <TwoColLayout>
      <ContentContainer>
        {isLoading ? (
          <FlexContainer fullHeight>
            <Spinner size="L" justify="center" align="center" />
          </FlexContainer>
        ) : (
          <>
            <Styled.CardContainer>
              {model.map(item => (
                <Styled.Card
                  key={item.testID}
                  testID={item.testID}
                  onClick={() => setValue(item.value)}
                  isActive={item.value === value}
                >
                  <FlexContainer justify="center" align="center">
                    {item.imageUrl}
                  </FlexContainer>
                  <Styled.TextContainer>
                    <Text type="paragraphs" size="M_L_M" color="dark" align="center">
                      {t(item.label)}
                    </Text>
                    <Text type="paragraphs" size="S_S_S" color="dark" align="center">
                      {t(item.description)}
                    </Text>
                  </Styled.TextContainer>
                </Styled.Card>
              ))}
            </Styled.CardContainer>
            <ValidationButtons value={value} onNextScreen={nextScreen} onPrevScreen={prevScreen} />
          </>
        )}
      </ContentContainer>
    </TwoColLayout>
  );
};

export default DataGatheringValidationAccess;
